var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.315 3.687H3.685a3.432 3.432 0 0 0-3.427 3.43v12.742a3.43 3.43 0 0 0 3.427 3.429h8.307L9 24.875c-.887.412-.27 1.769.626 1.363.051-.039 5.312-2.809 5.374-2.85l5.293 2.813a.74.74 0 0 0 .351.088c.765.031 1.045-1.079.356-1.414l-2.992-1.587h8.307a3.431 3.431 0 0 0 3.427-3.428V7.117a3.432 3.432 0 0 0-3.427-3.43zm1.927 16.171a1.928 1.928 0 0 1-1.927 1.929H3.685a1.93 1.93 0 0 1-1.927-1.928V7.117c0-1.065.862-1.928 1.927-1.929h22.63a1.93 1.93 0 0 1 1.927 1.928z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.678 10.024H8.032a.75.75 0 0 0 0 1.5h2.073V16.2a.75.75 0 0 0 1.5 0v-4.676h2.073c.981-.004.981-1.495 0-1.5zM22.297 10.1a.75.75 0 0 0-1.003.345l-1.972 4.042-1.971-4.044c-.435-.88-1.779-.226-1.351.66l2.648 5.426c.258.545 1.089.549 1.348 0l2.646-5.426a.75.75 0 0 0-.345-1.003z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.be5bff9d493b4f1c9925577cc37b7cc9.svg";
export { ForwardRef as ReactComponent };